import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./DashboardUserStudent.scss"; // Import SCSS styles
import StudentImage from "../../Assets/Images/AIRobot.svg"; // Adjust the path based on the folder structure
import Papers from "./ImageforDashboardStudent/Paper.svg"; // Adjust the path based on the folder structure
import { ReactComponent as Arrowicon } from "./ImageforDashboardStudent/iconoir_arrow-up-tag.svg"; // Adjust the path based on the folder structure
import { ReactComponent as Arrowrighticon } from "./ImageforDashboardStudent/rightside_arrow-up-tag.svg"; // Adjust the path based on the folder structure
import { ReactComponent as Mark } from "./ImageforDashboardStudent/Mark.svg"; // Adjust the path based on the folder structure
import { ReactComponent as Time } from "./ImageforDashboardStudent/Time.svg"; // Adjust the path based on the folder structure
import Viedoimage from "./ImageforDashboardStudent/Rectangle 10.png"; // Adjust the path based on the folder structure
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { decode } from "../../Utils/encodeDecode";
import { ILoginResponse } from "../Login/ILogin";
import Pricingimage from "./ImageforDashboardStudent/icon.png"; // Adjust the path based on the folder structure
import Pricingthirdimage from "./ImageforDashboardStudent/iconpermium.png"; // Adjust the path based on the folder structure
import AvatarImage from "../../Assets/Images/Chatbot_Avatar.png";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import {
  Paper,
  LinearProgress,
  useTheme,
  useMediaQuery,
  Grid,
  SvgIcon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Container,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  Stack,
  Avatar,
  CircularProgress,
} from "@mui/material";
import ReactECharts from "echarts-for-react";
import {
  clearDashboardChart,
  dashboardChart,
} from "../../Redux/Slices/DashboardChart/DashboardChart";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import ButtonField from "../../Components/Button/ButtonField";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import { useNavigate } from "react-router-dom";
import { pendingExamList } from "../../Redux/Slices/UserPackage/PendingExamListSlice";
import { clearListPracticeExamID } from "../../Redux/Slices/PracticeExam/ListPracticeExamIDSlice";
import { clearpendingPracticeExam } from "../../Redux/Slices/PendingPracticeExam/PendingPracticeExamSlice";
import { clearlistEvaluationPracticewritingExam } from "../../Redux/Slices/PracticeExam/ListEvaluationPracticewritingExamSlice";
import { clearEditStudentExamPracticeResponse } from "../../Redux/Slices/StudentExamPractice/EditStudentExamPracticeSlice";
import { Card } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import {
  Box,
  Modal,
  IconButton,
  Typography,
  CardContent,
  Button,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { CheckCircle } from "@mui/icons-material";
import { listUserPackage } from "../../Redux/Slices/UserPackage/ListUserPackageSlice";
import { AddSubscription } from "../../Redux/Slices/Subscription/AddSubscriptionSlice";
import { listSubscription } from "../../Redux/Slices/Subscription/ListSubscriptionSlice";
import AppBarnav from "../../Components/AppBar/AppBar";
import Menus from "../../Components/Menu/Menu";
import IconButtonField from "../../Components/Button/IconButtonField";
import Avatars from "../../Components/Avatar/Avatars";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { ReactComponent as Rightarrow } from "./ImageforDashboardStudent/Newrightarrow.svg";
import { ReactComponent as Newplay } from "./ImageforDashboardStudent/pase.svg";
import { ReactComponent as New } from "./ImageforDashboardStudent/Newplay.svg";
import ProgressCard from "./Progresscard";
import ActivityDashboard from "./ActivityDashboard";
import PerformanceTrendCard from "./PerformanceTrendCard";
import QuestionBankStatus from "./QuestionBankStatus";
import Performanceattandcard from "./Performancechatandcard";
import { listQuestionBank } from "../../Redux/Slices/NewDashboardAPI/ListQuestionBankSlice";
import { listRecentActivity } from "../../Redux/Slices/NewDashboardAPI/ListRecentActivitySlice";
import { listPrefmanceTrend } from "../../Redux/Slices/NewDashboardAPI/ListPrefmanceTrendSlice";
import { listQuestionType } from "../../Redux/Slices/QuestionType/ListQuestionTypeSlice";
import {
  listPerformance,
  ListPerformanceSlice,
} from "../../Redux/Slices/NewDashboardAPI/ListPerformanceSlice";
import { listDashboardprogress } from "../../Redux/Slices/NewDashboardAPI/ListDashboardprogressSlice";
import { listDailygoals } from "../../Redux/Slices/NewDashboardAPI/ListdailygoalsSlice";
import { Popover } from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { listdaycalculation } from "../../Redux/Slices/day_calculation/ListdaycalculationSlice";
import ChatbotPublic from "../../Components/ChatbotPublic/ChatbotPublic";
import ChatIcon from "@mui/icons-material/Chat";
import { clearChatbotPublicStatus } from "../../Redux/Slices/ChatbotPublic/ChatbotPublicSlicer";
import { dashboardweeklypref } from "../../Redux/Slices/DashboardData/Dashboardweeklypref";
import { failurelistSettingReset } from "../../Redux/Slices/Setting/ListSettingResetSlice";
import { listDashboardPerformenceTrend } from "../../Redux/Slices/QuestionType/ListDashboardPerformanceTrend";
import { listVideoTutorials } from "../../Redux/Slices/VideoTutorials/ListVideoTutorialsSlice";
import { IVideoTutorial } from "../VideoPage/IVideoTutorial";
import PricingDialog from "../../Components/PricingDialog/PricingDialog";
import { motion, AnimatePresence } from "framer-motion";
import UserProfileSection from "../../Components/UserProfileSection/UserProfileSection";

const DashboardUserStudent = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isUCAT = window.location.hostname.split(".")[0]?.includes("ucat")
  // || window.location.hostname.split(".")[0] === "192"

  // Domain determination
  const hostname = window.location.hostname;
  let domain = "test"; // default for 192/127
  if (hostname.includes("ucat")) {
    domain = "ucat";
  } else if (hostname.includes("learn")) {
    domain = "learn";
  }

  const [details, setDetails] = useState<ILoginResponse>({});

  useEffect(() => {
    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, []);

  const name: any = details?.username;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  useEffect(() => {
    dispatch(dashboardChart());
  }, [dispatch]);

  const { data: DashboardCards } = useAppSelector(
    (state) => state.DashboardChart
  );

  const Dashboarduser: any = DashboardCards?.data;




  const loginResponse = useAppSelector((state) => state.LoginSlicer);

  const { data: pendingExamLists } = useAppSelector(
    (state) => state.PendingExamList
  );

  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );
  const { data: AddUserSliceLoading } = useAppSelector(
    (state) => state.AddCreategoalsSlice
  );

  const { data: Listdaycalculation } = useAppSelector(
    (state) => state.ListdaycalculationSlice
  );
  const Days: any = Listdaycalculation?.data;


  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];

  useEffect(() => {
    dispatch(listUser());
    dispatch(listdaycalculation());
    dispatch(listQuestionBank());
    // dispatch(listQuestionType());
    dispatch(listDashboardPerformenceTrend());
    dispatch(listRecentActivity());
    dispatch(listDashboardprogress());
    dispatch(listPerformance({ period: null }));
    dispatch(listPrefmanceTrend({ questiontype_id: null }));
    dispatch(listUserPackage());
    dispatch(pendingExamList());
    dispatch(listVideoTutorials({ domain }));
    sessionStorage.removeItem("pending_time");
    sessionStorage.removeItem("student_exam_id");
    sessionStorage.removeItem("sectionreexamId");
    sessionStorage.removeItem("sectionId");
    sessionStorage.removeItem("response");
    sessionStorage.removeItem("question_id");
    sessionStorage.removeItem("question_type");

    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, [dispatch]);

  useEffect(() => {
    dispatch(listDailygoals());
  }, [dispatch, AddUserSliceLoading]);
  useEffect(() => {
    dispatch(clearListPracticeExamID());
    dispatch(clearpendingPracticeExam());
    dispatch(clearlistEvaluationPracticewritingExam());
    dispatch(clearEditStudentExamPracticeResponse());
  }, [dispatch]);

  // is pending exam list popup
  const [openUnder, setOpenUnder] = useState(false); // Step 1

  const [openProfile, setOpenProfile] = useState(false); // Step 1
  const [openPricing, setOpenPricing] = useState(false); // Step 2
  const [openPendingExam, setOpenPendingExam] = useState(false); // Step 3
  const [opensubscriptionExam, setOpensubscriptionExam] = useState(false); // Step 3
  const [profileChecked, setProfileChecked] = useState(false); // Internal flow control
  const [pricingChecked, setPricingChecked] = useState(false);




  useEffect(() => {
    dispatch(dashboardweeklypref());
  }, [dispatch]);
  const { data: weeklyPref } = useAppSelector(
    (state) => state.DashboardweeklyprefSliceReducer
  );

  const weeklyTip = weeklyPref?.data?.recommendation || "No tip available.";
  // useLayoutEffect(() => {
  //   setOpenUnder(true);
  // }, [Dashboarduser?.is_subscribed]);

  useEffect(() => {
    if (Dashboarduser) {
      const popupFlag = localStorage.getItem("subscribepopupfalse");

      // If no flag stored AND user is not subscribed
      if (!popupFlag && (Dashboarduser?.is_subscribed === false || Dashboarduser?.is_subscribed === "false")) {
        setOpensubscriptionExam(true);
        localStorage.setItem("subscribepopupfalse", "true");
      } else {
        setOpensubscriptionExam(false)
      }

    }
  }, [Dashboarduser]);


  useLayoutEffect(() => {
    // We only want to auto-close these if the user IS subscribed.
    // If it's expired, we should still allow them to see the pricing options.
    if (Dashboarduser?.is_subscribed === true || Dashboarduser?.is_subscribed === "true") {
      setOpensubscriptionExam(false);
      setOpenPricing(false);
    }
  }, [Dashboarduser?.is_subscribed]);


  // / STEP 1: Check if profile is missing
  useEffect(() => {
    if (
      ListUserSliceLoading?.message === "No profile found" ||
      ListUser[0]?.yeargroup_country_map_id === null ||
      ListUser[0]?.yeargroup_country_map_id === "" ||
      ListUser[0]?.yeargroup_country_map_id === 0
    ) {
      setOpenProfile(true); // Open profile popup
    } else {
      setProfileChecked(true); // Skip to next step
    }
  }, [ListUser, Dashboarduser?.is_subscribed, ListUserSliceLoading]);

  // STEP 2: When profile popup is closed, check subscription
  console.log("popup delay", Date.now() < parseInt(sessionStorage.getItem("clickedMaybeLater") || "0"))
  useEffect(() => {
    if (profileChecked && !openProfile) {
      if (
        (sessionStorage.getItem("clickedMaybeLater") && Date.now() < parseInt(sessionStorage.getItem("clickedMaybeLater") || "0"))
      ) {
        setOpenPricing(false); // suppressed by "Maybe Later"
        setPricingChecked(true); // Move to next step
      } else if (Dashboarduser?.is_subscribed === false || Dashboarduser?.is_subscribed === "false") {
        setOpenPricing(true); // Open pricing popup
      } else {
        setPricingChecked(true); // Skip to next step
      }
    }
  }, [profileChecked, openProfile, Dashboarduser]);

  // STEP 3: When pricing popup is closed, check for pending exams
  useEffect(() => {
    if (Dashboarduser) {
      const popupFlag = localStorage.getItem("pendingExamLists_popupfalse");

      if (pricingChecked && !openPricing) {
        if (!popupFlag && pendingExamLists?.status === true && (pendingExamLists?.data?.length ?? 0) > 0) {
          setOpenPendingExam(true);
          localStorage.setItem("pendingExamLists_popupfalse", "true");
        } else {
          setOpenPendingExam(false);
        }
      }
    }
  }, [pricingChecked, openPricing, pendingExamLists]);

  // video is list

  const [openvideo, setOpenvideo] = useState(false);

  const handleClosevideo = () => setOpenvideo(false);

  // video modal open
  const handleOpen = () => {
    setOpenvideo(true);
    setAnchorEl(null);
  };

  // video list
  const { data: videoTutorialsData, isLoading: isVideosLoading } =
    useAppSelector((state) => state.ListVideoTutorialsSlice);

  const videoList: IVideoTutorial[] = Array.isArray(videoTutorialsData?.data)
    ? (videoTutorialsData?.data as IVideoTutorial[])
    : (videoTutorialsData?.data?.video_tutorials || []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVideoReady, setIsVideoReady] = useState(false);
  const currentVideo = videoList[currentIndex];

  const handleNextvideo = () => {
    setIsVideoReady(false);
    setCurrentIndex((prev) => (prev + 1) % videoList.length);
  };

  const handlePrevideo = () => {
    setIsVideoReady(false);
    setCurrentIndex((prev) => (prev - 1 + videoList.length) % videoList.length);
  };

  const handleVideoSelect = (index: number) => {
    setIsVideoReady(false);
    setCurrentIndex(index);
  };

  // Fallback to clear loader if iframe onLoad fails
  useEffect(() => {
    if (openvideo && !isVideoReady) {
      const timer = setTimeout(() => {
        setIsVideoReady(true);
      }, 5000); // 5 second fallback
      return () => clearTimeout(timer);
    }
  }, [openvideo, isVideoReady, currentIndex]);

  // Pricing  popup

  const { data: listUserPackageSlice } = useAppSelector(
    (state) => state.ListUserPackageSlice
  );
  const Packages: any = Array.isArray(listUserPackageSlice?.data)
    ? listUserPackageSlice?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];

  const { data: SubscriptionSlice, isLoading: scriptionSlice } = useAppSelector(
    (state) => state.ListSubscriptionSlice
  );
  const Subcriptiondetails: any = SubscriptionSlice;

  const { isLoading: addingSubscription } = useAppSelector(
    (state) => state.AddSubscriptionSlice
  );

  const isSubscriptionProcessing = addingSubscription || scriptionSlice || Subcriptiondetails?.status === true;

  useLayoutEffect(() => {
    if (Subcriptiondetails?.status === true) {
      navigate("/subscribedPages");
    }
  }, [Subcriptiondetails]);

  // Popup

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isHoveringCard, setIsHoveringCard] = useState(false);
  const [isHoveringPopup, setIsHoveringPopup] = useState(false);
  const closeTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleCardEnter = (event: React.MouseEvent<HTMLElement>) => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setAnchorEl(event.currentTarget);
    setIsHoveringCard(true);
  };

  const handleCardLeave = (event: React.MouseEvent<HTMLElement>) => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setAnchorEl(event.currentTarget);
    setIsHoveringCard(false);
    setIsHoveringPopup(false);
    startCloseTimer();
  };

  const handlePopupEnter = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setIsHoveringPopup(true);
  };

  const handlePopupLeave = () => {
    setIsHoveringPopup(false);
    setAnchorEl(null);
    startCloseTimer();
  };

  const startCloseTimer = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => {
      if (!isHoveringCard && !isHoveringPopup) {
        setAnchorEl(null);
      }
    }, 300);
  };

  // const handleButtonClick = () => {
  //   alert("Platform Tutorial Clicked!");
  // };

  const open = Boolean(anchorEl);

  const [chatbotOpen, setChatbotOpen] = React.useState<boolean>(false);

  return (
    <>
      <div className="DashboardStudentAlingment">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div>
            <div
              className="DashboardStudent"
              style={{ fontWeight: "700", marginTop: "20px" }}
            >
              {isUCAT ? "UCAT" : "GATE"} AI Online Question Bank
            </div>
            <div className="StudentPractice">
              Track your {isUCAT ? "UCAT" : "GATE"} exam preparation progress on the Dashboard!
            </div>
          </div>
          <UserProfileSection />
        </div>

        <div className="containerstudent">
          <div className="firststudent">
            <div className="customCardStudent">
              <div style={{ display: "flex" }}>
                <div className="textContentStudent">
                  <Typography variant="h5" className="textsytleheadingStudent">
                    Welcome back, {ListUser[0]?.student_name}!
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "16px",
                      color: "#FFFFFF",
                      marginBottom: "10px",
                      fontWeight: 400,
                    }}
                  >
                    Your next {isUCAT ? "UCAT" : "GATE"} exam is in{" "}
                    {Days?.days_left ? Days?.days_left : "0"} days. Ready to
                    continue your preparation?
                  </Typography>
                  <div className="hide-on-small">
                    {(pendingExamLists?.data?.length ?? 0) > 0 && (
                      <Button
                        variant="contained"
                        className="resetldashboard"
                        onClick={() => {
                          navigate("/examprogress");
                        }}
                      >
                        <SvgIcon
                          component={Newplay}
                          sx={{ marginRight: "15px", fill: "white" }}
                        />
                        Resume Last Session
                      </Button>
                    )}
                    <Button
                      className="resetalldashboard"
                      onClick={() => {
                        navigate("/practicetest");
                      }}
                    >
                      Start New Practice
                      <SvgIcon
                        component={Rightarrow}
                        color="inherit"
                        sx={{ marginLeft: "15px" }}
                      />
                    </Button>
                  </div>
                </div>
              </div>
              <div className="weekly">
                <div
                  style={{
                    fontSize: "15px",
                    color: "#FFFFFF",
                    marginBottom: "5px",
                    fontWeight: 600,
                  }}
                >
                  WEEKLY TIP
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#FFFFFF",
                    fontWeight: 400,
                  }}
                >
                  {weeklyTip}
                </div>
              </div>
              {/* <img className="image" src={Papers} alt="Right Image" /> */}
            </div>
          </div>
          <div className="TwocardforDashboard">
            <div
              className="secondstudent"
              onMouseEnter={handleCardEnter}
              onMouseLeave={handleCardLeave}
            >
              <Box
                sx={{
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    maxWidth: 345,
                    width: "100%",
                    borderRadius: "5px",
                    position: "relative",
                    cursor: "pointer",
                    height: "100%",
                    background:
                      "linear-gradient(90deg, #2563eb 0%, #009dff 100%)", // <-- Linear gradient
                    boxShadow:
                      "rgba(0, 0, 0, 0.25) 0px 0px 10px,rgba(0, 0, 0, 0.12) 0px -1px 3px,rgba(0, 0, 0, 0.09) 0px -3px 5px",
                    "@media (max-width:1300px)": {
                      maxWidth: "none", // Remove maxWidth at 1300px+
                    },
                  }}
                >
                  <SvgIcon
                    component={New}
                    sx={{
                      fontSize: "50px",
                      color: "#009DFF",
                      position: "absolute",
                      top: "20%",
                      left: "40%",
                      "@media (max-width:1300px)": {
                        left: "48%", // Remove maxWidth at 1300px+
                      },
                    }}
                  />

                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      background: "white",
                      padding: "8px 12px",
                      boxSizing: "border-box",
                      color: "#fff",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                      borderRadius: " 0px 0px 5px 5px",
                    }}
                  >
                    <div>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: "bold",
                          color: "black",
                          fontSize: { xs: "1rem", md: "1.2rem" },
                        }}
                      >
                        Getting Started
                      </Typography>
                      <Typography
                        sx={{
                          color: "#6b7280",
                          fontSize: { xs: "1rem", md: "1.2rem" },
                        }}
                      >
                        Quick platform overview (2:15)
                      </Typography>
                    </div>
                    <KeyboardDoubleArrowRightIcon
                      onClick={() => {
                        navigate("/tutorials");
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </div>
          </div>
        </div>
        <Box sx={{ mt: 2, mb: 2 }}>
          {/* Chat Suggestion Box */}
          <Paper
            elevation={0}
            sx={{
              borderRadius: "10px",
              p: "24px",
              display: "flex",
              justifyContent: "space-between",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
              alignItems: "center",
              flexDirection: isMobile ? "column" : "row",
              gap: 2,
              margin: "0",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <div className="blinking-avatar-container1">
                <Avatar
                  src={AvatarImage}
                  alt="Profile"
                  className="blinking-avatar1"
                />
              </div>

              <Box>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "18px",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  Hey, I'm Elliot, your virtual assistant
                </Typography>
                <Typography sx={{ fontSize: "14px", color: "#424242" }}>
                  You can ask me anything related to your exam preparation.
                </Typography>
              </Box>
            </Stack>

            <Button
              variant="contained"
              sx={{
                borderRadius: "10px",
                fontWeight: 600,
                textTransform: "none",
                px: 3,
                py: 1,
                color: "white",
                fontSize: "15px",
                backgroundColor: "#009dff",
                "&:hover": {
                  backgroundColor: "#1976d2",
                },
              }}
              onClick={() => {
                setChatbotOpen(true);
                dispatch(clearChatbotPublicStatus());
              }}
            >
              ASK ELLIOT
            </Button>
          </Paper>
        </Box>
        {chatbotOpen && (
          <ChatbotPublic open={chatbotOpen} setOpen={setChatbotOpen} />
        )}

        {/* ------card design-- */}
        <ProgressCard setOpenPricing={setOpenPricing} />
        {/* ----- */}

        <Performanceattandcard />

        {/* --------two card -design -------- */}
        <ActivityDashboard />

        {/* -------graph line----- */}

        <PerformanceTrendCard />
        {/* ------QuestionBankStatus------ */}
        <br />
        <QuestionBankStatus />
        <br />
      </div>
      <button
        className="floating-chatbot-button "
        onClick={() => {
          setChatbotOpen(true);
          dispatch(clearChatbotPublicStatus());
        }}
      >
        <img
          src={AvatarImage}
          alt="Chat with Elliot"
          className="chatbot-avatar"
        />
      </button>

      <React.Fragment>
        <Dialog
          open={openUnder}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <ReportGmailerrorredIcon
              sx={{ fontSize: "50px", color: "#009dff" }}
            />
            <div style={{ fontSize: "20px", color: "#009dff" }}>
              {" "}
              Website Under Maintenance
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px" }}
            >
              Our website is currently undergoing an upgrade and is temporarily
              unavailable. Please try again after 24 hours. We appreciate your
              patience and understanding.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <button
              className="card-buttonexam"
              onClick={() => {
                navigate("/login");
                setOpenUnder(false);
              }}
            >
              ok
            </button>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      <React.Fragment>
        <Dialog
          open={openProfile}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <ReportGmailerrorredIcon
              sx={{ fontSize: "50px", color: "#009dff" }}
            />
            <div style={{ fontSize: "20px", color: "#009dff" }}>
              {" "}
              Please update Profile
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px" }}
            >
              Please update your profile/year level to ensure accurate exam
              assignment.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <button
              className="card-buttonexam"
              onClick={() => {
                navigate("/setting");
                setOpenProfile(false);
                setProfileChecked(true);
              }}
            >
              Update profile
            </button>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      <React.Fragment>
        <Dialog
          open={openPendingExam}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <ReportGmailerrorredIcon
              sx={{ fontSize: "50px", color: "#009dff" }}
            />
            <div style={{ fontSize: "20px", color: "#009dff" }}>Warning</div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px" }}
            >
              Your exam is in progress. Are you ready to continue?{" "}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <ButtonField
              className="form_save_button"
              onClick={() => {
                navigate("/examprogress");
                setOpenPendingExam(false);
              }}
            >
              Yes
            </ButtonField>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setOpenPendingExam(false)}
            >
              No
            </ButtonField>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      <React.Fragment>
        <Dialog
          open={opensubscriptionExam}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
              width: "30rem",
            }}
          >
            <ReportGmailerrorredIcon
              sx={{ fontSize: "50px", color: "#009dff" }}
            />
            <div style={{ fontSize: "20px", color: "#009dff" }}>Warning</div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px", textAlign: "center" }}
            >
              {Dashboarduser?.subscription_status}
            </DialogContentText>
          </DialogContent>

          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <ButtonField
              className="form_cancel_buttonsub"
              onClick={() => setOpensubscriptionExam(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className={`form_save_buttonssub ${isSubscriptionProcessing ? "bg-grey" : ""}`}
              onClick={() => {
                // dispatch(AddSubscription());
                // dispatch(
                //   listSubscription({
                //     package_id: Packages[0]?.package_id,
                //   })
                // );
                setOpensubscriptionExam(false);
                setOpenPricing(true);
              }}
            >
              {isSubscriptionProcessing ? (
                <>
                  <CircularProgress size={24} color="inherit" />
                  <span style={{ marginLeft: "10px" }}>Please wait ...</span>
                </>
              ) : (
                "Continue to Payment"
              )}
            </ButtonField>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      {/* Modal for video */}

      <Modal open={openvideo}>
        {/* Video Area with Previews */}
        <>
          <Box sx={{ width: "100%", position: "relative" }}>
            <IconButton
              sx={{
                position: "absolute",
                top: 6,
                right: 38,
                m: 1, // optional: adds margin from edges
                color: "#FFFFFF",
                zIndex: 2,
                backgroundColor: "gray",
              }}
              onClick={handleClosevideo}
            >
              <CloseIcon
                sx={{ fontSize: "20px", color: "white", fontWeight: 600 }}
              />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
              width: "100%",
              height: "100%",
              mb: 2,
            }}
          >
            {/* Left Preview + Arrow */}
            <Box sx={{ width: "10%", position: "relative" }}>
              <IconButton
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translateY(-50%)",
                  color: "#FFFFFF",
                  zIndex: 2,
                }}
                onClick={handlePrevideo}
              >
                <ArrowBackIosNewIcon sx={{ fontSize: "50px" }} />
              </IconButton>
            </Box>

            {/* Center Main Video */}
            <Box
              sx={{
                width: "80%",
                height: "90vh",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
              }}
            >
              <AnimatePresence>
                <motion.div
                  key={currentIndex}
                  initial={{ opacity: 0, scale: 0.98, x: 20 }}
                  animate={{ opacity: 1, scale: 1, x: 0 }}
                  exit={{ opacity: 0, scale: 1.02, x: -20 }}
                  transition={{
                    duration: 0.4,
                    ease: "easeOut",
                  }}
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                  }}
                >
                  {(!isVideoReady) && (
                    <Box
                      sx={{
                        position: "absolute",
                        zIndex: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        gap: 2,
                      }}
                    >
                      <CircularProgress size={60} sx={{ color: "white" }} />
                      <Typography color="white" variant="body2">
                        Loading Video...
                      </Typography>
                    </Box>
                  )}
                  {currentVideo ? (
                    <iframe
                      width="100%"
                      height="100%"
                      src={`${currentVideo?.video_url}?autoplay=1`}
                      title={currentVideo?.category_info?.meta_value}
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                      onLoad={() => setIsVideoReady(true)}
                      style={{
                        borderRadius: "20px",
                        opacity: isVideoReady ? 1 : 0,
                        transition: "opacity 0.3s ease",
                        border: "none",
                      }}
                    />
                  ) : (
                    <Typography variant="h6" color="white">
                      No video selected
                    </Typography>
                  )}
                </motion.div>
              </AnimatePresence>
            </Box>

            {/* Right Preview + Arrow */}
            <Box sx={{ width: "10%", position: "relative" }}>
              <IconButton
                sx={{
                  position: "absolute",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#FFFFFF",
                  zIndex: 2,
                }}
                onClick={handleNextvideo}
              >
                <ArrowForwardIosIcon sx={{ fontSize: "50px" }} />
              </IconButton>
            </Box>
          </Box>
        </>
      </Modal>

      <PricingDialog
        open={openPricing}
        onClose={() => setOpenPricing(false)}
        isUCAT={isUCAT}
        Packages={Packages}
        isSubscriptionProcessing={isSubscriptionProcessing}
        setPricingChecked={setPricingChecked}
      />


      {/* Popover with Button */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => (setAnchorEl(null), setIsHoveringCard(false))}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          onMouseEnter: handlePopupEnter,
          onMouseLeave: handlePopupLeave,
          sx: {
            pointerEvents: "auto",
            width: 300,
            p: 0,
            borderRadius: 2,
            overflow: "hidden",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: 150,
            cursor: "pointer",

            backgroundColor: "#f5f7fa",
          }}
          onClick={handleOpen}
        >
          <PlayCircleOutlineIcon sx={{ fontSize: 40, color: "#009EFF" }} />
        </Box>
        <Box sx={{ p: 2 }}>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            sx={{ fontSize: "18px" }}
          >
            Platform Tutorial
          </Typography>
          <Typography variant="body2" sx={{ fontSize: "14px" }}>
            Learn how to use all features of the {isUCAT ? "UCAT" : "GATE"} exam preparation platform
            to maximize your score.
          </Typography>
        </Box>
      </Popover>
    </>
  );
};

export default DashboardUserStudent;
